import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionTitle({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = '查看全部',
  icon,
  action,
}: SectionTitleProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        {eyebrow && (
          <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-600 mb-2">
            {eyebrow}
          </p>
        )}
        <h2 className="flex items-center gap-2 text-xl md:text-2xl font-bold text-foreground-950">
          {icon && <i className={`${icon} text-primary-500`} aria-hidden="true" />}
          {title}
        </h2>
        {description && <p className="mt-2 text-sm text-foreground-600 max-w-2xl">{description}</p>}
      </div>
      {action}
      {moreTo && (
        <Link
          to={moreTo}
          className="group inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}